<template>
  <BaseLayout :showLocaleSwitcher="false">
    <div>
      <div class="flex-grow w-full max-w-7xl mx-auto lg:flex">
        <div class="lg:hidden">
          <div class="flex items-end py-4 px-4">
            <!-- <div v-if="monthlyTotal > 0" class="flex-1">
              <h2 class="text-base font-semibold text-gray-900 uppercase">{{ $t('place_order.monthly_fee') }}</h2>
              <div class="mt-1 text-sm text-alo-400 font-bold">
                <WebMoneyFormatted :amount="monthlyTotal" />
                /{{ $t('place_order.month') }}
              </div>
            </div> -->

            <!-- <div class="flex-1">
              <div class="mt-1 text-sm text-alo-400 font-bold">
                <WebMoneyFormatted :amount="payTodayTotal" />
              </div>
            </div> -->

            <!-- <divok
              class="open-summary cursor-pointer text-gray-900 hover:text-gray-500"
              tabindex="0"
              @click="openSummaryPopup"
            >
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="chevron-down"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
              >
                <path
                  fill="currentColor"
                  d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
                />
              </svg>
            </divok> -->
          </div>
        </div>

        <div class="lg:flex-1">
          <slot />
        </div>

        <!-- <div
          class="z-10 absolute overflow-y-auto top-0 left-0 right-0 bg-white lg:bg-gray-100 lg:static lg:block lg:w-2/5 lg:shrink-0"
          :class="{ hidden: !showSummaryPopUp }"
        >
          <div
            class="close-summary absolute top-5 right-5 cursor-pointer text-gray-900 hover:text-gray-500 lg:hidden"
            @click="closeSummaryPopup"
          >
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="times"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 352 512"
            >
              <path
                fill="currentColor"
                d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
              />
            </svg>
          </div>

          <div class="h-full py-6 px-6 lg:pt-0 lg:pl-12">
            <h2 class="text-2xl font-medium text-alo-400">{{ $t('place_order.summary') }}</h2>

            <template v-if="monthlyTotal > 0">
              <h2 class="mt-8 text-lg font-semibold text-gray-900 uppercase">{{ $t('place_order.monthly_fee') }}</h2>

              <template v-for="(listing, index) in summary.listings">
                <div
                  v-if="listing.name && listing.monthlyPrice > 0"
                  :key="`month-listing-${index}`"
                  class="mt-2 flex justify-between"
                >
                  <div class="mt-1 text-sm text-gray-600">
                    {{ listing.showQuantity ? listing.quantity + 'x' : '' }}
                    {{ listing.name }}
                  </div>
                  <div class="mt-1 text-sm text-gray-600">
                    <WebMoneyFormatted :amount="listing.monthlyPrice * listing.quantity" />
                  </div>
                </div>
              </template>

              <div v-for="(fee, index) in summary.fees" :key="`month-fee-${index}`" class="mt-2 flex justify-between">
                <div class="mt-1 text-sm text-gray-600">
                  {{ fee.showQuantity ? fee.quantity + 'x' : '' }}
                  {{ fee.name }}
                </div>
                <div class="mt-1 text-sm text-gray-600">
                  <WebMoneyFormatted :amount="fee.monthlyPrice * fee.quantity" />
                </div>
              </div>

              <div class="mt-2 flex justify-between border-t border-gray-200">
                <div class="mt-1 text-sm text-gray-800 font-bold">{{ $t('place_order.total') }}</div>
                <div class="mt-1 text-base text-gray-800 text-alo-400 font-bold whitespace-nowrap">
                  <WebMoneyFormatted :amount="monthlyTotal" />
                  /{{ $t('place_order.month') }}
                </div>
              </div>
            </template>

            <h2 class="mt-8 text-lg font-semibold text-gray-900 uppercase">{{ $t('place_order.pay_today') }}</h2>

            <template v-for="(listing, index) in summary.listings">
              <div v-if="listing.name && listing.price > 0" :key="`listing-${index}`" class="mt-2 flex justify-between">
                <div class="mt-1 text-sm text-gray-600">
                  {{ listing.showQuantity ? listing.quantity + 'x' : '' }}
                  {{ listing.name }}
                </div>
                <div class="mt-1 text-sm text-gray-600">
                  <WebMoneyFormatted :amount="listing.price * listing.quantity" />
                </div>
              </div>
            </template>

            <div v-for="(fee, index) in summary.fees" :key="`fee-${index}`" class="mt-2 flex justify-between">
              <div class="mt-1 text-sm text-gray-600">
                {{ fee.showQuantity ? fee.quantity + 'x' : '' }}
                {{ $t('place_order.start_up_fees') }} ({{ fee.name }})
              </div>
              <div class="mt-1 text-sm text-gray-600">
                <WebMoneyFormatted :amount="fee.price * fee.quantity" />
              </div>
            </div>

            <div
              v-for="(shipping, index) in summary.shippings"
              :key="`shipping-${index}`"
              class="mt-2 flex justify-between"
            >
              <div class="mt-1 text-sm text-gray-600">{{ $t('place_order.transport') }}</div>
              <div class="mt-1 text-sm text-gray-600">
                <WebMoneyFormatted :amount="shipping.price" />
              </div>
            </div>

            <template v-for="(deposit, index) in summary.deposits">
              <div v-if="hasDeposit" :key="`deposit-${index}`" class="mt-2 flex justify-between">
                <div class="mt-1 text-sm text-gray-600">{{ $t('place_order.deposit') }}</div>
                <div class="mt-1 text-sm text-gray-600">
                  <WebMoneyFormatted :amount="deposit.price" />
                </div>
              </div>
            </template>

            <div class="mt-2 flex justify-between border-t border-gray-200">
              <div class="mt-1 text-sm text-gray-800 font-bold">{{ $t('place_order.total') }}</div>
              <div class="mt-1 text-base text-alo-400 font-bold">
                <WebMoneyFormatted :amount="payTodayTotal" />
              </div>
            </div>

            <div class="mt-8 flex">
              <img src="https://doc.alo.es/img/icons/visa.svg" alt="Icono Visa" class="w-11" />
              <img src="https://doc.alo.es/img/icons/mastercard.svg" alt="Icono Mastercard" class="w-11 ml-4" />
            </div>
          </div>
        </div>
        <div
          class="fixed top-0 left-0 right-0 bottom-0 bg-gray-700/50 lg:hidden"
          :class="{ hidden: !showSummaryPopUp }"
          @click="closeSummaryPopup"
        ></div> -->
      </div>
    </div>
  </BaseLayout>
</template>

<script>
import BaseLayout from '@/Web/Layouts/Base.vue'
//import WebMoneyFormatted from '@/Web/Components/WebMoneyFormatted.vue'

export default {
  components: {
    //WebMoneyFormatted,
    BaseLayout,
  },

  props: {
    summary: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      showSummaryPopUp: false,
    }
  },

  computed: {
    monthlyTotal() {
      return (this.summary.fees ?? []).reduce((acc, fee) => acc + (fee.monthlyPrice ?? 0) * fee.quantity, 0)
    },
    payTodayTotal() {
      return (
        (this.summary.fees ?? []).reduce((acc, fee) => acc + (fee.price ?? 0) * fee.quantity, 0) +
        (this.summary.shippings ?? []).reduce((acc, shipping) => acc + (shipping.price ?? 0) * shipping.quantity, 0) +
        (this.summary.deposits ?? []).reduce((acc, deposit) => acc + (deposit.price ?? 0) * deposit.quantity, 0)
      )
    },
    hasDeposit() {
      return 0 < this.summary.deposits.length
    },
  },

  methods: {
    openSummaryPopup() {
      this.showSummaryPopUp = true
    },
    closeSummaryPopup() {
      this.showSummaryPopUp = false
    },
  },
}
</script>

<style lang="scss" scoped>
.open-summary,
.close-summary {
  width: 16px;
  height: auto;
}
</style>
